import React, { useEffect, useState } from "react";
import { Checkbox, Dropdown, Input, message, Select, Tag } from "antd";
import { TableGrid } from "../../../Component/Table";
import "./style.scss";
import Api from "../../../Network/ApiConfig";
import moment from "moment";
import { CSVLink } from "react-csv";
import { DownOutlined } from "@ant-design/icons";
import { StyleToPRint } from "../../../Component/jsonsStyles/styleJson";
import { useSelector } from "react-redux";
import ar from "../../../localization/ar";
import en from "../../../localization/en";

export const CancelationReport = () => {
  const pdfRef = React.createRef();
  const [callBack, setCallBack] = useState([]);
  const [callBackList, setCallBackList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [defaultCurrentVal, setDefaultCurrentVal] = useState(10);
  const [columns, setColumns] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [TotalCount, setTotalCount] = useState(30);
  const { currentLang } = useSelector((state) => state?.user);
  const [page, setpage] = useState(0);

  const t = currentLang === "en" ? en : ar;

  // {
  //   title: <p className="table-header-text"> {t.OrderID} </p>,
  //   dataIndex: "OrderId",
  //   render: (_, record) => <a> #{record?.OrderId}</a>,
  // },
  // {
  //   title: <p className="table-header-text"> {t.CreatorName} </p>,
  //   dataIndex: "OrderId",
  //   render: (_, record) => <a> #{record?.OrderId}</a>,
  // },
  //   {
  //     title: <p className='table-header-text'> User <span> المستخدم </span></p>,
  //     render: (_, record) => <div className='col-name-holder'> <span>{record?.Customer?.AspNetUsers?.FullName} </span> {record?.Customer?.TotalRate ? <Rate disabled defaultValue={record?.Customer?.TotalRate} /> : null} </div> ,
  //   },
  // {
  //   title: <p className="table-header-text"> {t.deliverycompany}</p>,
  //   dataIndex: "CompanyName",
  //   // render: (_, record) => <span>{record?.Total} LE </span>,
  // },
  // {
  //   title: <p className="table-header-text"> {t.Status}</p>,
  //   dataIndex: "OrderStatusName",
  //   render: (_, record) => <span>{record?.OrderStatusName} </span>,
  // },
  // {
  //   title: <p className="table-header-text"> {t.CancelationReason}</p>,
  //   dataIndex: "CancelationReason",
  //   // render: (_, record) => <span>{record?.Total} LE </span>,
  // },
  // {
  //   title: <p className="table-header-text"> {t.Driver}</p>,
  //   dataIndex: "DeliveryName",
  //   render: (_, record) => <span>{record?.DeliveryName} </span>,
  // },
  // {
  //   title: <p className="table-header-text">{t.cancelationdate}</p>,
  //   dataIndex: "CreationDate",
  //   render: (_, record) => {
  //     return <p> {moment(record?.CreationDate)?.format("YYYY-MM-DD ")} </p>;
  //   },
  // },

  const fetchListData = (index = 0) => {
    setLoading(true);
    setpage(index);
    Api.get(`AdminAPIs/CancelationOrderReport?Page=${index}`).then(
      (res) => {
        setLoading(false);
        if (res?.status === 200) {
          const data = res?.data?.model?.map((item, ind) => ({
            Id: ind + 1 + index * 30,
            ...item,
          }));
          setCallBack(data);
          setCallBackList(data);
          setColumns([
            Object.keys(data[0]).map((key) => {
              return {
                title: key?.replace(/([A-Z])/g, " $1")?.trim(), // Convert camelCase to spaced words
                dataIndex: key,
                key: key,
                render: (text) =>
                  text !== null && text !== undefined ? text : "N/A", // Handle null or undefined values
              };
            }),
          ]);
          if (res?.data?.metas?.TotalaCount) {
            setTotalCount(res?.data?.metas?.TotalaCount);
          }
        }
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    fetchListData();
  }, []);

  // useEffect(() => {
  //   if (columns.length && callBack.length) {
  //     const data = callBack?.map((item) => {
  //       let obj = {};
  //       columns?.map((dataIndex) => {
  //         if (dataIndex && dataIndex?.dataIndex === "date")
  //           return (obj[dataIndex?.title?.props?.children[0]?.toUpperCase()] =
  //             moment(item[dataIndex.dataIndex]).format("DD/MM/YYYY"));
  //         else
  //           return (obj[dataIndex.title.props.children[0]?.toUpperCase()] =
  //             item[dataIndex.dataIndex]);
  //       });
  //       return obj;
  //     });
  //     setExcelData(data);
  //   }
  // }, [columns]);

  useEffect(() => {
    if (callBack.length && columns[0].length) {
      const data = callBack?.map((item) => {
        let obj = {};

        columns[0]?.forEach((column) => {
          const dataIndex = column.dataIndex;
          const title = column.title?.props?.children[0]?.toUpperCase() || "";

          if (dataIndex.toLowerCase().includes("date")) {
            obj[title] = moment(item[dataIndex]).format("DD/MM/YYYY");
          } else {
            obj[title] =
              item[dataIndex] !== null && item[dataIndex] !== undefined
                ? item[dataIndex]
                : "N/A"; // Handle null or undefined values
          }
        });

        return obj;
      });

      setExcelData(data);
    }
  }, [columns, callBack]);

  const handelPrint = () => {
    var bodyPrint = document.getElementById("print-section").innerHTML;
    var mywindow = window.open("", "PRINT");
    mywindow.document.write("<html><head>");
    mywindow.document.write(
      '<link href="https://fonts.googleapis.com/css2?family=Cairo:wght@200;300;400;600;700;900&display=swap" rel="stylesheet">'
    );
    mywindow.document.write(`<style> ${StyleToPRint}</style>`);
    mywindow.document.write(bodyPrint);
    mywindow.document.write("</body></html>");
    mywindow.document.title = t.cancelationReport;
    setTimeout(() => {
      mywindow.document.close();
      mywindow.focus();
      mywindow.print();
      mywindow.close();
    }, 200);
  };

  return (
    <div className="product__wrapper">
      <TableGrid
        TableRef={pdfRef}
        title={
          <div className="table__filter">
            <p className="table__title"> {t.cancelationReport}</p>
            <div className="download__list">
              <CSVLink
                filename={`${t.cancelationReport}.csv`}
                data={callBackList || []}
              >
                {t.Excel}
              </CSVLink>
              <a onClick={handelPrint}>{t.Print}</a>
            </div>
          </div>
        }
        columns={columns[0] || []}
        dataSource={callBackList || []}
        loading={loading}
        pageSize={30}
        total={TotalCount}
        onChange={(pagination) => {
          fetchListData(pagination?.current - 1);
        }}
        scrollX={1400}
      />
    </div>
  );
};
